import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { href: '/', label: '首页' },
    { href: '/category/dianying', label: '电影' },
    { href: '/category/dianshiju', label: '电视剧' },
    { href: '/category/zongyi', label: '综艺' },
    { href: '/category/dongman', label: '动漫' },
    { href: '/category/jilupian', label: '纪录片' },
    { href: '/about', label: '关于我们' },
  ];

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <h1 className="font-heading text-2xl font-bold text-primary-500">
              51<span className="text-foreground-900">视频</span>
            </h1>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                  isActive(link.href)
                    ? 'text-primary-500 bg-primary-50'
                    : `text-foreground-700 hover:text-primary-500 hover:bg-background-100 ${!scrolled ? 'text-white' : ''}`
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                scrolled
                  ? 'text-foreground-600 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer text-foreground-700"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <nav className="md:hidden bg-white border-t border-background-200/70 py-3 px-4" aria-label="移动端导航">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive(link.href)
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}